/**
 * LineFormatter — desktop port of BigxBookApp/src/printing/engine/LineFormatter.ts.
 * Pure string padding helpers used by the receipt builder.
 */

export const hr = (width: number, char = '-'): string => char.repeat(width);

export const centerText = (value: string, width: number): string => {
  const text = value.length > width ? value.slice(0, width) : value;
  const left = Math.floor((width - text.length) / 2);
  const right = width - text.length - left;
  return `${' '.repeat(Math.max(0, left))}${text}${' '.repeat(Math.max(0, right))}`;
};

export const padRight = (value: string, width: number): string => {
  const text = value.length > width ? value.slice(0, width) : value;
  return `${text}${' '.repeat(Math.max(0, width - text.length))}`;
};

export const padLeft = (value: string, width: number): string => {
  const text = value.length > width ? value.slice(0, width) : value;
  return `${' '.repeat(Math.max(0, width - text.length))}${text}`;
};

export const twoCol = (left: string, right: string, width: number): string => {
  if (right.length >= width) return right.slice(0, width);
  const maxLeft = width - right.length - 1;
  const leftSafe = left.length > maxLeft ? left.slice(0, maxLeft) : left;
  const spaces = width - leftSafe.length - right.length;
  return `${leftSafe}${' '.repeat(Math.max(1, spaces))}${right}`;
};
